import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { AiOutlineExclamationCircle } from "react-icons/ai";
const HtmlTooltip = styled(({ className, ...props }: any) => (
  <Tooltip {...props} classes={{ popper: className }} placement="top" arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    borderRadius: "10px",
  },
}));

function TooltipMsg({ msg, color }:any) {
  return (
    <HtmlTooltip title={<small className="Montserrat">{msg}</small>}>
      <i>
        <AiOutlineExclamationCircle className={`cursur f-16 ${color && color}`} />
      </i>
    </HtmlTooltip>
  );
}

export default TooltipMsg;
